import HttpRequest from './http_request'
const {cloudFunction: { key }} = require('@/config')

class StepPricingProvider extends HttpRequest {
  constructor () {
    super(`${process.env.NEW_API}/`)
  }
  async getAllStepPricing () {
    this.setHeader({
      'key': key
    })
    try {
      const { data: { data } } = await this.get('step-pricing/object')
      return data
    } catch (error) {
      alert(`${error} => /getAllStepPricing`)
      return `${error} => /getAllStepPricing`
    }
  }
}

export default StepPricingProvider



// WEBPACK FOOTER //
// ./src/resources/step_pricing_provider.js